import React, { memo, forwardRef } from "react";
const SvgShiftOutlined = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M15.239 6.346l-.757-.654.757.654zm-6.993 8.087l-.757-.654.757.654zm8.506-8.087L15.995 7l.757-.654zm6.993 8.087l-.756.654.756-.654zm-3.75 1.654v-1a1 1 0 00-1 1h1zm-8 7.932h1-1zm0-7.932h1a1 1 0 00-1-1v1zm2.488-10.395l-6.994 8.087 1.513 1.308L15.995 7l-1.512-1.308zm3.025 0a2 2 0 00-3.025 0L15.995 7l1.513-1.308zm6.993 8.087l-6.993-8.087L15.995 7l6.994 8.087L24.5 13.78zm-1.512 3.308c1.712 0 2.633-2.012 1.512-3.308l-1.512 1.308v2zm-2.993 0h2.993v-2h-2.993v2zm-1-1v7.932h2v-7.932h-2zm0 7.932v2a2 2 0 002-2h-2zm0 0h-6v2h6v-2zm-6 0h-2a2 2 0 002 2v-2zm0 0v-7.932h-2v7.932h2zm-3.994-6.932h2.994v-2H9.002v2zM7.489 13.78c-1.12 1.296-.2 3.308 1.513 3.308v-2L7.489 13.78z"
      />
    </svg>
  );
});
SvgShiftOutlined.displayName = "SvgShiftOutlined";
const MemoForwardRef = memo(SvgShiftOutlined);
export default MemoForwardRef;
